import React from 'react';

import { Center, Left, Right, Scale } from './AngleOffset.style';

interface AngleOffsetProps {
    angle: number;
}

const AngleOffset: React.FC<AngleOffsetProps> = ({ angle }) => (
    <Scale angle={angle}>
        {angle < 0 && <Left angle={angle}>{-1 * angle}°</Left>}
        {angle > 0 && <Right angle={angle}>{angle}°</Right>}
        {angle === 0 && <Center>0°</Center>}
    </Scale>
);

export default AngleOffset;
